import { Link } from 'react-router-dom'
import Card from '@/components/ui/Card'

const logoSlots = new Array(6).fill(null)

const faqs = [
  {
    q: 'How do collaborations start?',
    a: 'Reach out with your vision and we’ll schedule a discovery call to map goals, budget, and timeline. We co-design a pilot that fits your capacity.',
  },
  {
    q: 'What reporting do partners receive?',
    a: 'You receive milestone updates, receipts, and highlights that show where every dollar goes—ready to share internally or with your community.',
  },
  {
    q: 'Can small businesses participate?',
    a: 'Yes. SMB cohorts pair nearby classrooms with local supporters so smaller gifts combine into powerful experiences.',
  },
]

export default function Partners() {
  return (
    <div className="space-y-16">
      <section className="space-y-6">
        <span className="inline-flex items-center rounded-full bg-shell px-3 py-1 text-xs font-semibold uppercase tracking-wide text-cocoa/70">
          Collaborate
        </span>
        <h1 className="text-4xl font-semibold text-cocoa">Partners & Affiliates</h1>
        <div className="space-y-4 text-lg text-cocoa/70">
          <p>
            We work shoulder-to-shoulder with organizations that want their support to reach classrooms directly. Our partners
            provide funding, in-kind materials, and expertise; we bring transparent execution, teacher-first design, and
            storytelling that shows where every dollar goes.
          </p>
          <p>
            Programs ride on the Smart Block Network (SBN): a connective layer that pairs educators with aligned partners,
            removes friction with smart tools, and keeps details grounded in a living “Reality Check” fact lattice. Together, we
            make it easy to start small, learn fast, and scale what works.
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          <Link className="btn" to="/partners/apply">
            Become a Partner
          </Link>
          <Link className="btn bg-white text-cocoa border border-sand hover:bg-shell" to="/programs">
            Browse Programs
          </Link>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-cocoa">Collaboration models</h2>
        <Card className="space-y-3 p-6 text-sm text-cocoa/80">
          <ul className="list-disc space-y-2 pl-5">
            <li>Program Sponsorship: Fund classroom experiences end-to-end with clear milestones and receipts.</li>
            <li>In-Kind Contributions: Provide materials (STEM kits, art supplies, laptops) matched to real classroom needs.</li>
            <li>SMB Cohorts: Local businesses co-fund nearby classrooms and receive ongoing updates.</li>
            <li>Cause Campaigns: Seasonal drives (Build-A-Bag, Thanksgiving, Holiday Giving) with visible impact.</li>
          </ul>
        </Card>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-cocoa">Future partner spotlight</h2>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {logoSlots.map((_, index) => (
            <Card key={index} className="flex h-32 items-center justify-center bg-white/70 text-sm text-cocoa/50">
              Logo Placeholder
            </Card>
          ))}
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-2xl font-semibold text-cocoa">FAQs</h2>
        <div className="space-y-4">
          {faqs.map(item => (
            <Card key={item.q} className="space-y-2 p-5">
              <h3 className="text-lg font-semibold text-cocoa">{item.q}</h3>
              <p className="text-sm text-cocoa/70">{item.a}</p>
            </Card>
          ))}
        </div>
      </section>
    </div>
  )
}
